import { CheckRounded } from "@mui/icons-material";
import { Menu, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { useState } from "react";

interface Props<T> {
  disabled?: boolean;
  label: string;
  value: string;
  suboptions: T[];
  selectedSuboptionValues: string[];
  onSelected: (selectedSuboptionValues: string[]) => void;
  suboptionLabelSelector?: (suboption: T) => string;
  suboptionValueSelector?: (suboption: T) => string;
}

const ToggleButtonSubmenu = <T,>(props: Props<T>) => {
  const [menuAnchor, setMenuAnchor] = useState<HTMLElement | null>(null);

  return (
    <>
      <ToggleButton value={props.value} disabled={props.disabled} onClick={(e) => setMenuAnchor(e.currentTarget)}>
        <Typography>{`${props.label} ${props.selectedSuboptionValues.length > 0 ? `(${props.selectedSuboptionValues.length})` : ""}`}</Typography>
      </ToggleButton>

      <Menu
        anchorEl={menuAnchor}
        open={Boolean(menuAnchor)}
        onClose={() => setMenuAnchor(null)}
        anchorOrigin={{
          horizontal: "right",
          vertical: "top",
        }}
        transformOrigin={{
          horizontal: "left",
          vertical: "top",
        }}
        slotProps={{ paper: { sx: { minWidth: 200 } } }}
      >
        <ToggleButtonGroup
          variant="menu"
          orientation="vertical"
          value={props.selectedSuboptionValues}
          onChange={(_, values) => props.onSelected(values)}
          sx={{ minWidth: "100%" }}
        >
          {props.suboptions.map((suboption, index) => (
            <ToggleButton key={index} value={props.suboptionValueSelector?.(suboption) ?? String(suboption)}>
              <Typography sx={{ textAlign: "left", flexGrow: 1 }}>
                {props.suboptionLabelSelector?.(suboption) ?? String(suboption)}
              </Typography>
              {props.selectedSuboptionValues.includes(
                props.suboptionValueSelector?.(suboption) ?? String(suboption),
              ) && <CheckRounded sx={{ ml: 1 }} />}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </Menu>
    </>
  );
};

export { ToggleButtonSubmenu };
